import { spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const DisclaimerText = styled.p`
  ${Text('bodyText', 'default')};
  padding-bottom: ${spacing(4)};
`
